import template from './employees.html';
import controller from './employees.controller';

let employeesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default employeesComponent;
